<form [formGroup]="form" class="form" *ngIf="formReady">
  <div class="form-body">

    <div class="form-section">
      <app-form-row [label]="'FORMS.COMMON.SALUTATION' | translateControl : form | async">
        <div class="row">
          <div class="col-6">
            <app-dropdown [options]="dropdownData.salutation" [labelKey]="'title'" [valueKey]="'value'"
              [mainForm]="form" [controlName]="'salutation'">
            </app-dropdown>
          </div>
        </div>
      </app-form-row>

      <app-form-row [label]="['FORMS.COMMON.LAST_NAME', 'FORMS.COMMON.FIRST_NAME'] | translateControl : form | async">
        <div class="row">
          <div class="col-6">
            <app-input [type]="'text'" [mainForm]="form" [controlName]="'lastName'" datatestid="lastNameInput">
            </app-input>
          </div>
          <div class="col-6">
            <app-input [type]="'text'" [mainForm]="form" [controlName]="'firstName'" datatestid="firstNameInput">
            </app-input>
          </div>
        </div>
      </app-form-row>

      <app-form-row [label]="'FORMS.COMMON.EMAIL' | translateControl : form | async">
        <app-input [type]="'text'" [mainForm]="form" [controlName]="'email'"  datatestid="emailInput">
        </app-input>
      </app-form-row>

      <app-form-row [label]="'FORMS.COMMON.PHONE' | translateControl : form | async">
        <app-input [type]="'text'" [mainForm]="form" [controlName]="'phone'">
        </app-input>
      </app-form-row>

      <app-form-row [label]="'FORMS.COMMON.MOBILE' | translateControl : form | async">
        <app-input [type]="'text'" [mainForm]="form" [controlName]="'mobile'">
        </app-input>
      </app-form-row>

      <app-form-row [label]="'FORMS.COMMON.FAX' | translateControl : form | async">
        <app-input [type]="'text'" [mainForm]="form" [controlName]="'fax'">
        </app-input>
      </app-form-row>

    </div>

  </div>

</form>
